import React, { useState } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { State } from "../../../core/store/interfaces";
import api from "../../../api";
import OwnerBlock from "./assign-users/OwnerBlock";
import {
  useLead,
  useLog,
  AppPermissions,
  useHasPermission,
  useConfiguration,
  LeadQuality,
  GeneralApprovalStatus,
} from "../../../core";
import MarkAsLost from "./button/MarkAsLost";
import moment from "moment";
import AcceptAsLost from "./button/AcceptAsLost";
import RejectAsLost from "./button/RejectAsLost";
import RevokeLost from "./button/RevokeLost";
import AddNewRequirement from "./actions/AddNewRequirement";
import { toastr } from "react-redux-toastr";
import ArrowLeftIcon from "../../../components/icons/arrow-left";

const LeadHeader: React.FunctionComponent<{
  onClose?: () => void;
  onOpenConfigurationPopup?: () => void;
  disablePrevArrow?: boolean;
  disableNextArrow?: boolean;
  showArchiveButton?: boolean;
  prevSlide?: () => void;
  nextSlide?: () => void;
  showNextPrev?: boolean;
  fetching?: boolean;
  onReload?: () => void;
}> = (props) => {
  const authState = useSelector((state: State) => state.authUser);
  const leadState = useSelector((state: State) => state.lead);

  const [showAddNewRequirement, setShowAddNewRequirement] = React.useState(
    false
  );

  const canUpdateLeadTitle = useHasPermission(AppPermissions.UpdateLeadTitle);
  const canCreateProposal = useHasPermission(AppPermissions.CreateProposal);
  const canCreateConfiguration = useHasPermission(
    AppPermissions.CreateRequirement
  );

  const canMarkLost = useHasPermission(AppPermissions.MarkLost);
  const canSetLeadQuality = useHasPermission(AppPermissions.SetLeadQuality);
  const canApproveLostRequest = useHasPermission(
    AppPermissions.ApproveLostRequest
  );
  const canRejectLostRequest = useHasPermission(
    AppPermissions.RejectLostRequest
  );
  const { updateLeadTitle } = useLead(api.lead);
  const { loadAllLog } = useLog(api.log);

  const { openModal } = useConfiguration(api);
  const [leadTitle, setLeadTitle] = useState<string>();
  const [archiveLeadConfirmation, setLeadManagerConfirmation] = useState(false);

  const [showLeadTitleEdit, setShowLeadTitleEdit] = useState<boolean>(false);
  const leadTitleUpdate = (e: { key: string }) => {
    if (e.key === "Enter" && leadTitle) {
      if (leadTitle !== leadState?.leadDetails?.title) {
        updateLeadTitle(leadTitle, leadState?.leadDetails?._id, () => {
          setShowLeadTitleEdit(false);
          loadAllLog({ page: 1, leadId: leadState?.leadDetails?._id });
        });
      } else {
        setShowLeadTitleEdit(false);
      }
    }
  };
  const setValidation = () => {
    if (
      !leadState?.leadDetails?.currentSalesPerson?._id &&
      !leadState?.leadDetails?.currentCRMAgent?._id
    ) {
      setShowAddNewRequirement(false);
      toastr.error(
        "Error",
        " Please assign Transaction Manager or Support Executive before creating a requirement"
      );
    }else{
      setShowAddNewRequirement(true);
    }
    // if (
    //   leadState?.leadDetails?.currentCRMAgent?._id &&
    //   !leadState?.leadDetails?.currentSalesPerson?._id
    // ) {
    //   setShowAddNewRequirement(false);
    //   toastr.error(
    //     "Error",
    //     "Please assign Transaction Manager before creating a Requirement"
    //   );
    // }
    // if (
    //   !leadState?.leadDetails?.currentCRMAgent?._id &&
    //   leadState?.leadDetails?.currentSalesPerson?._id
    // ) {
    //   setShowAddNewRequirement(false);
    //   toastr.error(
    //     "Error",
    //     "Please assign Support Executive before creating a Requirement"
    //   );
    // }
  };
  const getCurrentStage = () => {
    const currentInstance = leadState?.leadDetails?.stagesTransitions
      ? leadState?.leadDetails?.stagesTransitions
          .filter((stage) => stage.isCurrentStage)
          .sort((st1, st2) => st1.position - st2.position)
          .find(() => true)
      : null;
    return currentInstance?.code;
  };

  const archiveLeadHandler = () => {
    if (
      leadState?.leadDetails?.isArchived === false
    ) {
      api.lead
        .archiveLead(true, leadState?.leadDetails?._id)
        .then((response) => {
          if (response.status === 200) {
            props?.onReload?.();
            toastr.success("Success", "Lead archived successfully!");
          }
        })
        .catch((error) => {
          // console.error("Error:", error);
        });
    } else {
      api.lead
      .archiveLead(false, leadState?.leadDetails?._id)
      .then((response) => {
        if (response.status === 200) {
          props?.onReload?.();
          toastr.success("Success", "Lead unarchived successfully!");
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
    }
  }

  const renderLeadManagerAssignConfirmation = () => {
    return archiveLeadConfirmation ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <div className="container">
                  <div className="font-weight-semibold pb-2">
                    {leadState?.leadDetails?.isArchived === false ? <p>Are you sure you want to Archive this lead?</p> : <p>Are you sure you want to Unarchive this lead?</p>}
                  </div>
                  <div className="row gutter-5 justify-content-center">
                    <div className="col-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4"
                        onClick={() => setLeadManagerConfirmation(false)}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="submit"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={() => archiveLeadHandler()}
                      >
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };

  return (
    <>
      <div className="container-fluid bg-gray-100 border-bottom py-3 position-sticky top-0 zIndex-9">
        <div className="row align-items-center">
          <div className="col-auto" onClick={props.onClose}>
            {/* <i className="icon-arrow-left text-gray-500 font-xxl cursor-pointer"></i> */}
            <ArrowLeftIcon className="text-gray-500 cursor-pointer rtl-rotate-180" />
          </div>
          <div className="col">
            {leadState?.leadDetails ? (
              <>
                <div className="font-base font-weight-bold mb-1 lead-title d-flex">
                  {!showLeadTitleEdit ? (
                    <>
                      {leadState?.leadDetails?.title}
                      {canUpdateLeadTitle &&
                        leadState?.leadDetails?.isEditable && (
                          <i
                            className="cursor-pointer icon-edit ml-4"
                            onClick={() => {
                              setShowLeadTitleEdit(true);
                              setLeadTitle(leadState?.leadDetails?.title);
                            }}
                          ></i>
                        )}
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        className={`form-control rounded-sm font-weight-semibold lead-title-input ${
                          leadTitle === "" ? "error-input" : ""
                        }`}
                        placeholder="Lead Title"
                        name="leadTitle"
                        value={leadTitle}
                        onChange={(e) => {
                          setLeadTitle(e.target.value);
                        }}
                        onKeyDown={leadTitleUpdate}
                        id="leadTitle"
                        maxLength={50}
                      />
                      <i
                        className="cursor-pointer icon-close-round ml-1 mt-2"
                        onClick={() => {
                          setShowLeadTitleEdit(false);
                        }}
                      ></i>
                    </>
                  )}
                </div>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb font-sm">
                    {leadState?.leadDetails?.createdAt && (
                      <li className="breadcrumb-item">
                        {format(
                          new Date(leadState?.leadDetails?.createdAt),
                          "MMM/dd/yyyy"
                        )}
                      </li>
                    )}
                    {leadState?.leadDetails?.primaryVehicleModel && (
                      <li className="breadcrumb-item">
                        {leadState?.leadDetails?.primaryVehicleModel.year}{" "}
                        {leadState?.leadDetails?.primaryVehicleModel.modelCode}{" "}
                        {leadState?.leadDetails?.primaryVehicleVariant?.name}
                      </li>
                    )}
                  </ol>
                </nav>
                <div className="font-weight-semibold font-xs mt-1">
                  {leadState?.leadDetails?.enquiryNumber}
                </div>
                {leadState?.leadDetails?.cityDetails?.cityName &&<div className="font-weight-semibold font-xs mt-1">
                  Lead City : {leadState?.leadDetails?.cityDetails?.cityName}
                </div>}
              </>
            ) : (
              <h5 className="mb-0">Add Lead</h5>
            )}
          </div>
          {leadState.leadDetails?.lostRequestDetails &&
            (leadState.leadDetails?.lostRequestDetails?.approvalStatus ===
              GeneralApprovalStatus.Pending ||
              (leadState.leadDetails?.lostRequestDetails?.approvalStatus ===
                GeneralApprovalStatus.Approved &&
                leadState.leadDetails?.quality !== LeadQuality.Interested)) && (
              <div className="col-auto mt-md-0 mt-1">
                <div>
                  <span className="font-normal font-weight-semibold d-block">
                    Lead Marked As Lost
                  </span>
                  <span className="font-sm">
                    {leadState.leadDetails?.lostRequestDetails
                      ?.approvalStatus === GeneralApprovalStatus.Pending && (
                      <>
                        {" "}
                        by{" "}
                        {
                          leadState.leadDetails?.lostRequestDetails?.initiatedBy
                            ?.name
                        }{" "}
                        {moment(
                          leadState.leadDetails?.lostRequestDetails?.requestedAt
                        ).format("DD/MMM/YYYY  hh:mm A")}
                      </>
                    )}
                    {leadState.leadDetails?.lostRequestDetails
                      ?.approvalStatus === GeneralApprovalStatus.Approved && (
                      <>
                        {" "}
                        Approved by{" "}
                        {
                          leadState.leadDetails?.lostRequestDetails?.validatedBy
                            ?.name
                        }{" "}
                        {moment(
                          leadState.leadDetails?.lostRequestDetails?.validatedAt
                        ).format("DD/MMM/YYYY  hh:mm A")}
                      </>
                    )}
                  </span>
                </div>
              </div>
            )}
          {leadState.leadDetails?.lostRequestDetails &&
            leadState.leadDetails?.lostRequestDetails?.approvalStatus ===
              GeneralApprovalStatus.Pending && (
              <div className="col-auto mt-md-0 mt-1">
                <div className="row">
                  {canApproveLostRequest && leadState.leadDetails?._id && (
                    <div className="bg-white col-auto ml-3 p-0">
                      <AcceptAsLost
                        leadId={leadState.leadDetails?._id}
                      ></AcceptAsLost>
                    </div>
                  )}
                  {canRejectLostRequest && leadState.leadDetails?._id && (
                    <div className="bg-white col-auto ml-3 p-0">
                      <RejectAsLost
                        leadId={leadState.leadDetails?._id}
                      ></RejectAsLost>
                    </div>
                  )}
                </div>
              </div>
            )}
          <div className="col-auto mt-md-0 mt-1">
            <div className="d-inline-flex align-items-center flex-wrap mr-lg-5 mr-sm-3">
              {props.showNextPrev && (
                <>
                  <div
                    className={`icon-box bg-white border d-inline-flex justify-content-center align-items-center font-sm cursor-pointer mr-1 ${
                      props.disablePrevArrow || props.fetching ? "disabled" : ""
                    }`}
                    onClick={() => props.prevSlide?.()}
                  >
                    <i className="icon-chevron-left"></i>
                  </div>
                  <div
                    className={`icon-box bg-white border d-inline-flex justify-content-center align-items-center font-sm cursor-pointer mr-2 ${
                      props.disableNextArrow || props.fetching ? "disabled" : ""
                    }`}
                    onClick={() => props.nextSlide?.()}
                  >
                    <i className="icon-chevron-right"></i>
                  </div>
                </>
              )}

              {canCreateConfiguration &&
                leadState.leadDetails?.quality === LeadQuality.Interested &&
                leadState.leadDetails?.isDeal &&
                (!leadState.leadDetails?.lostRequestDetails ||
                  leadState.leadDetails?.lostRequestDetails?.approvalStatus ===
                    GeneralApprovalStatus.Rejected ||
                  (leadState.leadDetails?.lostRequestDetails?.approvalStatus ===
                    GeneralApprovalStatus.Approved &&
                    leadState.leadDetails?.quality ===
                      LeadQuality.Interested)) &&
                leadState.leadDetails?.isEditable &&
                !leadState.leadDetails?.customer?.isBlocked && (
                  <button
                    onClick={() => {
                      setShowAddNewRequirement(true);
                      setValidation();
                    }}
                    className="btn btn-primary mr-lg-2 mr-1 px-lg-4 px-2 mb-sm-0 mb-1 font-weight-semibold"
                  >
                    Create Requirement
                  </button>
                )}

              {leadState.leadDetails?.currentStatus !== "lost" &&
                leadState.leadDetails?.isDeal &&
                leadState.leadDetails?._id &&
                canMarkLost &&
                leadState.leadDetails?.quality === LeadQuality.Interested &&
                (!leadState.leadDetails?.lostRequestDetails ||
                  leadState.leadDetails?.lostRequestDetails?.approvalStatus ===
                    GeneralApprovalStatus.Rejected ||
                  (leadState.leadDetails?.lostRequestDetails?.approvalStatus ===
                    GeneralApprovalStatus.Approved &&
                    leadState.leadDetails?.quality ===
                      LeadQuality.Interested)) && (
                  <div className="bg-white">
                    <MarkAsLost
                      leadId={leadState.leadDetails?._id}
                      lead={leadState.leadDetails}
                    ></MarkAsLost>
                  </div>
                )}
              {leadState.leadDetails?.currentStatus === "lost" &&
                leadState.leadDetails?._id &&
                canSetLeadQuality &&
                leadState.leadDetails?.quality !== LeadQuality.Interested && (
                  <div className="bg-white">
                    <RevokeLost
                      leadId={leadState.leadDetails?._id}
                    ></RevokeLost>
                  </div>
                )}
              {leadState.leadDetails?.lostRequestDetails &&
                leadState.leadDetails?.lostRequestDetails?.approvalStatus ===
                  GeneralApprovalStatus.Pending &&
                leadState.leadDetails?._id &&
                canSetLeadQuality &&
                !canApproveLostRequest &&
                !canRejectLostRequest &&
                leadState.leadDetails?.lostRequestDetails?.initiatedBy?._id ===
                  authState?.profile?._id && (
                  <div className="bg-white">
                    <RevokeLost
                      leadId={leadState.leadDetails?._id}
                    ></RevokeLost>
                  </div>
                )}
            </div>

            {!leadState.leadDetails?.isDeal && (
              <OwnerBlock
                user={leadState.leadDetails?.currentCRMAgent}
                title="Support Executive"
                // title="Transaction Manager"
                className="d-inline-flex align-items-center mr-lg-5"
              ></OwnerBlock>
            )}

            <OwnerBlock
              user={leadState.leadDetails?.currentSalesPerson}
              title="Transaction Manager"
              // title="Support Executive"
              className="d-inline-flex align-items-center"
            ></OwnerBlock>

            {props.showArchiveButton && <span className="ml-3">
                <button className="btn btn-primary" onClick={() => {
                  setLeadManagerConfirmation(true)
                }}>  {!leadState?.leadDetails?.isArchived ? "Archive Lead" : "Unarchive Lead"}</button>
            </span>}

            {renderLeadManagerAssignConfirmation()}
          </div>
        </div>
      </div>
      {showAddNewRequirement && (
        <AddNewRequirement
          className="row mx-0"
          lead={leadState?.leadDetails}
          leadId={leadState?.leadDetails?._id || ""}
          customerId={leadState?.leadDetails?.customer?._id || ""}
          onClose={() => setShowAddNewRequirement(false)}
          onReload={() => {
            props.onReload?.();
          }}
        ></AddNewRequirement>
      )}
    </>
  );
};

export default LeadHeader;
